import React from 'react';
import { Col, Divider, Row } from 'antd';

export default function FluxoCaixaMensalLocalSintetico({valoresProvisionados}) {
    return (
        <div>
            <div className="col-layout b-color-secondary text-center f-16">
                Local: <b>Loja Matriz</b>
            </div>
            <Row gutter={[8,0]} className="f-14">
                <Col span={12} align="right">
                    <div>Caixa 1: <b className="c-primary">100,00</b></div>
                    <div>Caixa 2: <b className="c-primary">200,00</b></div>
                </Col>
                <Col span={12} align="left">
                    <div>Caixa 1: <b className="c-primary">100,00</b></div>
                    <div>Caixa 2: <b className="c-primary">200,00</b></div>
                </Col>
            </Row>
            <Divider className="m-0"/>
            <Row gutter={[8,0]} className="m-t-5 f-14">
                <Col span={12} align="right">
                    <div>SALDO INICIAL: <b className="c-primary">100,00</b></div>
                </Col>
                <Col span={12} align="left">
                    <div>SALDO FINAL: <b className="c-primary">100,00</b></div>
                </Col>
            </Row>

            {valoresProvisionados && 
                <div className="tabela-fluxo m-t-19">
                    <Row className="b-color-secondary col-layout c-black t-head">
                        <Col align="center" span={4}><b>DATA</b></Col>
                        <Col align="center" span={10}>
                            <Row>
                                <Col span={24} align="center"><b>ENTRADA</b></Col>
                            </Row>
                            <Row>
                                <Col span={12} align="right"><b>PREVISTO</b></Col>
                                <Col span={12} align="right"><b>REALIZADO</b></Col>
                            </Row>
                        </Col>
                        <Col align="center" span={10}>
                            <Row>
                                <Col span={24} align="center"><b>SAÍDA</b></Col>
                            </Row>
                            <Row>
                                <Col span={12} align="right"><b>PREVISTO</b></Col>
                                <Col span={12} align="right"><b>REALIZADO</b></Col>
                            </Row>
                        </Col>
                    </Row>
                    <div className="t-body p-0">
                        <Row className="row">
                            <Col span={4}>OUTUBRO/2020</Col>
                            <Col className="col" span={10}>
                                <Row>
                                    <Col span={12} align="right">1.000,00</Col>
                                    <Col span={12} align="right">1.000,00</Col>
                                </Row>
                            </Col>
                            <Col className="col" span={10}>
                                <Row>
                                    <Col span={12} align="right">1.000,00</Col>
                                    <Col span={12} align="right">1.000,00</Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row className="row">
                            <Col span={4}>NOVEMBRO/2020</Col>
                            <Col className="col" span={10}>
                                <Row>
                                    <Col span={12} align="right">1.000,00</Col>
                                    <Col span={12} align="right">1.000,00</Col>
                                </Row>
                            </Col>
                            <Col className="col" span={10}>
                                <Row>
                                    <Col span={12} align="right">1.000,00</Col>
                                    <Col span={12} align="right">1.000,00</Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row className="c-primary row">
                            <Col span={4}><b>TOTAL DO PERÍODO</b></Col>
                            <Col className="col c-primary" span={10}>
                                <Row>
                                    <Col span={12} align="right">2.000,00</Col>
                                    <Col span={12} align="right">2.000,00</Col>
                                </Row>
                            </Col>
                            <Col className="col c-red" span={10}>
                                <Row>
                                    <Col span={12} align="right">2.000,00</Col>
                                    <Col span={12} align="right">2.000,00</Col>
                                </Row>
                            </Col>
                        </Row>
                    </div>
                </div>
            }
            
            {!valoresProvisionados &&
                <div className="tabela-fluxo m-t-19">
                    <Row className="b-color-secondary col-layout c-black">
                        <Col span={4}><b>DATA</b></Col>
                        <Col align="right" span={10}><b>ENTRADA</b></Col>
                        <Col align="right" span={10}><b>SAÍDA</b></Col>
                    </Row>
                    <div className="t-body p-0">
                        <Row className="row">
                            <Col span={4}>OUTUBRO/2020</Col>
                            <Col align="right" span={10}>1.000,00</Col>
                            <Col align="right" span={10}>1.000,00</Col>
                        </Row>
                        <Row className="row">
                            <Col span={4}>NOVEMBRO/2020</Col>
                            <Col align="right" span={10}>1.000,00</Col>
                            <Col align="right" span={10}>1.000,00</Col>
                        </Row>
                        <Row className="c-primary row">
                            <Col span={4}><b>TOTAL DO PERÍODO</b></Col>
                            <Col align="right" className="c-primary" span={10}><b>2.000,00</b></Col>
                            <Col align="right" className="c-red" span={10}><b>2.000,00</b></Col>
                        </Row>
                    </div>
                </div>
            }
        </div>
    );
}